/* eslint-disable */
import styled, { css } from 'styled-components';
import cssKit from '../../css';
import selectArrowTransparent from '../../assets/select-arrow-transparent.png';

// Styling
const nissan = process.env.BRAND_NAME === 'nissan';

export const lightBlueErrorColor = () => {
  return 'rgba(124, 176, 232, 0.3)';
};

export const darkBlueErrorColor = () => {
  return 'rgba(43, 77, 140, 1)';
};

export const placeholderErrorColor = () => {
  return 'rgba(25, 135, 241, 1)';
};

export const errorCopyStyles = () => {
  return css`
    font-family: ${cssKit.fonts.arial};
    font-weight: bold;
    font-size: 11px;
    line-height: 14px;
    letter-spacing: 0.5px;
    color: ${cssKit.vars.color_white_rgba(1)};

    ${cssKit.media.greaterThan('medium') `
      font-size: 14px;
      line-height: 17px;
    `};
  `;
};

export const selectLabelStyles = (props) => {
  return css`
    /* position: absolute; */
    width: 100%;
    top: 0;
    padding: 10px 0 5px 0;
    background-color: ${props.fieldError ? 'transparent' : '#fff'};

    ${cssKit.media.greaterThan('medium') `
      padding: 0 0 10px 0;
    `};
  `;
};

export const FormStyled = styled.form`
  position: relative;
  padding: 0 20px;
  display: ${(props) => {
    return props.hideForm ? 'none' : 'block';
  }};

  ${cssKit.media.greaterThan('medium') `
    padding: 0 35px;
  `};

  &:before,
  &:after {
    content: '';
    display: ${(props) => (props.noBg ? 'none' : 'block')};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 90%;
    z-index: -1;

    ${cssKit.media.greaterThan('medium') `
      height: 78%;
    `};
  }
  &:after {
    top: 90%;
    transform-origin: 0 0;
    transform: skewX(70deg);

    ${cssKit.media.greaterThan('medium') `
      top: 78%;
      transform: skewX(80deg);
    `};
  }
`;

export const FormLabelOuterWrapperStyled = styled.label`
  font-family: ${cssKit.fonts.regular};
  border: none;
  box-shadow: none;
  position: relative;
  display: ${(props) => {
    return props.display ? props.display.small : 'inline-block';
  }};
  width: ${(props) => {
    return props.width ? props.width.small + '%' : '100%';
  }};
  vertical-align: top;
  margin: 0 0 34px 0;
  padding: ${(props) => {
    return props.padding ? props.padding.small : '0';
  }};

  ${(props) =>
    props.type === 'checkbox' &&
    css`
      margin: 0 0 20px 0;
      min-height: 20px;
    `};

  ${cssKit.media.greaterThan('medium') `
    display: ${(props) => {
      return props.display ? props.display.large : 'inline-block';
    }};
    width: ${(props) => {
      return props.width ? props.width.large + '%' : '100%';
    }};
    padding: ${(props) => {
      return props.padding ? props.padding.large : '0';
    }};
    margin: 0 0 48px 0;
  `};
`;

export const FormLabelInnerWrapperStyled = styled.div`
  border: none;
  box-shadow: none;
  position: relative;
  transition: background-color 500ms ease-in;
  ${(props) =>
    props.fieldError &&
    props.dealerList &&
    css`
      background-color: transparent;
    `};

  ${(props) =>
    props.type === 'select' &&
    css`
      padding: 0 .5rem .5rem .5rem;
      ${cssKit.mixins.hoverIgnoreTouch(`
        &:hover span svg{
          ${cssKit.mixins.arrowBounce()};
        }
      `)};
    `
  };

    ${(props) =>
    props.type === 'checkbox' &&
    css`
        margin-left: auto;
        margin-right: ${nissan ? 'auto' : 'auto !important'};
        width: ${nissan ? '100%' : '80%'};
      `
  }
`;

export const FormLabelCopyStyled = styled.span`
  border: none;
  box-shadow: none;
  display: block;
  position: relative;
  font-family: ${cssKit.fonts.regular};
  text-transform: uppercase;
  font-size: 11px;
  line-height: 11px;
  letter-spacing: 2px;
  padding: 0 0 5px 0;
  color: #000;
  z-index: 2;
  pointer-events: none;
  -webkit-font-smoothing: auto;

  ${(props) =>
    props.dealerList &&
    css`
      color: white;
      display: inline-block;
      width: 33.33%;
      vertical-align: middle;
    `};

  ${(props) =>
    props.type === 'select' &&
    css`
      ${selectLabelStyles(props)};
    `};

  ${(props) =>
    props.type === 'checkbox' &&
    css`
      cursor: pointer;
      top: -4px;
      line-height: 15px;
      padding: 0 0 5px 35px;
    `};

  ${cssKit.media.greaterThan('medium') `
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 2.5px;
    padding: 0 0 10px 0;

    ${(props) =>
      props.type === 'checkbox' &&
      css`
        line-height: 18px;
        padding: 4px 0 10px 40px;
      `};
  `};
`;

export const FormLabelCopyAddOnStyled = styled.span`
  display: block;
  position: absolute;
  top: 0;
  right: 0;
`;

export const FormLabelSvgAddOnStyled = styled.span`
  display: block;
  width: 16px;
  position: absolute;
  top: 0;
  right: 0;
`;

export const placeHolderStyles = (props) => {
  const styles = () => {
    return `
      font-family: ${cssKit.fonts.light};
      font-style: italic;
      color: ${props.fieldError ? placeholderErrorColor() : '#868686'};
    `;
  };
  return `
    ::-webkit-input-placeholder {
        ${styles()};
    }
    ::-moz-placeholder {
        ${styles()};
    }
    :-ms-input-placeholder {
        ${styles()};
    }
    :-moz-placeholder {
        ${styles()};
    }
    `;
};
export const checkboxStyles = (checked) => {
  return `
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    cursor: pointer;
    border: 1px solid #4a4a4a;

    & span {
      display: block;
      position: relative;
      top: 3%;
      left: 47%;
      width: 100%;
      height: 100%;
      transform: rotate(-45deg);
      z-index: 1;
      transition: opacity 350ms ease-out;
      opacity: ${checked ? 1 : 0};

      &:before,
      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 1px;
        height: 15%;
        background-color: #4a4a4a;
      }
      &:after {
        width: 50%;
        height: 1px;
        top: 15%;
        left: 0;
      }
    }
  `;
};
export const FormInputStyled = styled.input`
    display: block;
    box-sizing: border-box;
    height: 2.4375rem;
    padding: .5rem;
    border: 1px solid #cacaca;
    margin: 0 0 1rem;
    font-family: inherit;
    font-size: 1rem;
    color: #000;
    background-color: #FFF;
    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    border-radius: 0;
    -webkit-transition: box-shadow .5s,border-color .25s ease-in-out;
    transition: box-shadow .5s,border-color .25s ease-in-out;
    -webkit-appearance: none;

  width: 100%;
  font-family: ${cssKit.fonts.regular};

  &:focus {
    border-color: ${cssKit.vars.color_black_rgba(1)};
  }

  ${(props) =>
    props.dealerList &&
    css`
      color: #000;
      width: 100%;
      background-color: #fff;
      border: 1px solid #e2e2e2;
      /* border-color: ${cssKit.vars.color_white_rgba(1)}; */
      text-align: center;
      display: inline-block;
      /* width: 66.66%; */
      vertical-align: middle;
      letter-spacing: 2px;

      &:focus {
        /* border-color: ${cssKit.vars.color_white_rgba(1)}; */
      }
    `};

  ${(props) =>
    props.type === 'checkbox' &&
    css`
      display: none;

      & + label {
        ${checkboxStyles()};
      }
      &:checked + label {
        ${checkboxStyles(true)};
      }
    `};

  ${cssKit.media.greaterThan('medium') `
    height: 33px;
    font-size: 24px;
    line-height: 24px;
  `};

  ${(props) => `${placeHolderStyles(props)}`};
`;

export const FormSelectStyled = styled.select`
  position: relative;
  width: 100%;
  height: 2.4375rem;
  font-size: 18px;
  line-height: 18px;
  padding: .2rem 0 .2rem .5rem;
  color: ${cssKit.vars.color_black_rgba(1)};
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-border-radius: 0;
  border: 1px solid #cacaca;
  font-family: ${cssKit.fonts.regular};
  background: url(${selectArrowTransparent}) no-repeat right center;
  appearance: none;
  ::-ms-expand {
    display: none;
  }
  background-color: transparent;
  cursor: pointer;
  z-index: 1;
  transition: background-color 500ms ease-in, border-color 500ms ease-in;

  &:focus {
    border-color: ${cssKit.vars.color_black_rgba(1)};
  }

  ${cssKit.media.greaterThan('medium') `
    font-size: 24px;
    line-height: 24px;
  `};

  ${(props) =>
    props.fieldError &&
    css`
      background-color: ${lightBlueErrorColor()};
    `};
`;

export const FormInlineErrorWrapperStyled = styled.div`
  position: relative;
  text-align: right;
  margin: 0 0 12px 0;
  opacity: 0;
  ${cssKit.mixins.fadeIn(1)};

  ${cssKit.media.greaterThan('medium') `
    margin: 0 0 16px 0;
  `};

  ${(props) =>
    props.dealerList &&
    css`
      position: absolute;
      bottom: 25px;
      right: 0;
      width: 66.66%;
    `};
`;

export const FormInlineErrorStyled = styled.div`
  position: relative;
  display: inline-block;
  text-align: left;
  padding: 4px 15px 7px 35px;
  background-color: ${darkBlueErrorColor()};

  &:after {
    content: '';
    ${cssKit.mixins.horizontalCenterAlign('absolute')};
    bottom: -6px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid ${darkBlueErrorColor()};

    ${cssKit.media.greaterThan('medium') `
      bottom: -8px;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid ${darkBlueErrorColor()};
    `};
  }

  ${cssKit.media.greaterThan('medium') `
    padding: 12px 20px 12px 45px;
  `};
`;

export const FormInlineErrorCopyStyled = styled.span`
  display: inline-block;
  ${errorCopyStyles};
`;

export const FormInlineErrorSvgWrapperStyled = styled.span`
  display: inline-block;
  ${cssKit.mixins.verticalCenterAlign('absolute')};
  left: -14px;
  width: 37px;

  ${cssKit.media.greaterThan('medium') `
    left: -21px;
    width: 50px;
  `};
`;

export const GenericFormErrorStyled = styled.div`
  position: relative;
  ${errorCopyStyles};
  margin: 0 0 20px 0;
  padding: 22px 20px 22px 68px;
  opacity: 0;
  background-color: ${darkBlueErrorColor()};
  ${cssKit.mixins.fadeIn(1)};

  ${cssKit.media.greaterThan('medium') `
    margin: 0 5% 27px 5%;
    padding: 30px 35px 30px 90px;
  `};

  ${(props) =>
    props.dealerList &&
    css`
      ${cssKit.media.greaterThan('small') `
        margin: 10px 50px 27px 50px;
      `};
      ${cssKit.media.greaterThan('medium') `
        margin: 20px 50px 27px 50px;
      `};
    `};
`;

export const GenericFormErrorSvgStyled = styled.span`
  display: inline-block;
  ${cssKit.mixins.verticalCenterAlign('absolute')};
  left: 15px;
  width: 37px;

  ${cssKit.media.greaterThan('medium') `
    left: 20px;
    width: 50px;
  `};
`;

export const PrivacyPolicyStyled = styled.span`
  display: block;
  text-align: ${nissan ? 'left' : 'center'};
  width: 100%;
  margin: 0 0 20px 0;

  a {
    font-size: 11px;
    line-height: 11px;
    letter-spacing: 2px;
    color: ${cssKit.vars.color_black_rgba(1)};
    text-decoration: underline;
    transition: color 350ms ease-out;

    ${cssKit.mixins.hoverIgnoreTouch(`
        &:hover {
          color: #9b9b9b;
        }
      `)};

    ${cssKit.media.greaterThan('medium') `
      font-size: 14px;
      line-height: 14px;
    `};
  }
`;

export const FormButtonWrapperStyled = styled.span`
  display: inline-block;
  text-align: center;
  margin: 0;
  width: ${nissan ? 'auto' : '100%'};
`;

export const DealerFormElemContainerStyled = styled.div`
  padding-top: 3rem;
  position: relative;
  width: 100%;

  ${cssKit.media.greaterThan('small') `
  width: 60%;
`};

  ${cssKit.media.greaterThan('medium') `
  width: 50%;
`};
`;

export const StyledInfoTextWrapper = styled.div`
  font-family: ${cssKit.fonts.regular};
  padding-bottom: .5rem;
  text-align: ${nissan ? '' : 'center'};
`;

export const StyledInfoText = styled.div`
  padding: .5rem;
`;

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/components/LeadsForm/styles.js
 **/